import { render, staticRenderFns } from "./lastMassages.vue?vue&type=template&id=2bf0a8a7&"
import script from "./lastMassages.vue?vue&type=script&lang=js&"
export * from "./lastMassages.vue?vue&type=script&lang=js&"
import style0 from "./lastMassages.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports